module.exports = __webpack_public_path__ + "img/hn.eefcc77.svg";